import { render, staticRenderFns } from "./TestTitle.vue?vue&type=template&id=0065c350&scoped=true&"
import script from "./TestTitle.vue?vue&type=script&lang=js&"
export * from "./TestTitle.vue?vue&type=script&lang=js&"
import style0 from "./TestTitle.vue?vue&type=style&index=0&id=0065c350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065c350",
  null
  
)

export default component.exports